if (!customElements.get('seasons-wedding-gallery')) {
  customElements.define('seasons-wedding-gallery', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.photos = Array.from(this.querySelectorAll('[data-sg-photo]'));
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.image = this.querySelector('[data-sg-full]');
      this.caption = this.querySelector('[data-sg-caption]');
      this.position = this.querySelector('[data-sg-position]');
      this.photos.forEach((photo, index) => photo.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.opener = photo;
        this.showPhoto(index);
        this.dialog.showModal();
      }, options));
      this.querySelector('[data-sg-close]').addEventListener('click', () => this.dialog.close(), options);
      this.querySelector('[data-sg-prev]').addEventListener('click', () => this.showPhoto(this.index - 1), options);
      this.querySelector('[data-sg-next]').addEventListener('click', () => this.showPhoto(this.index + 1), options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.showPhoto(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      this.dialog.addEventListener('close', () => this.opener?.focus({ preventScroll: true }), options);
      this.dialog.addEventListener('touchstart', event => {
        this.touchStart = { x: event.changedTouches[0].clientX, y: event.changedTouches[0].clientY };
      }, { ...options, passive: true });
      this.dialog.addEventListener('touchend', event => {
        if (!this.touchStart) return;
        const dx = event.changedTouches[0].clientX - this.touchStart.x;
        const dy = event.changedTouches[0].clientY - this.touchStart.y;
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) this.showPhoto(this.index + (dx < 0 ? 1 : -1));
        this.touchStart = null;
      }, { ...options, passive: true });
    }
    showPhoto(index) {
      this.index = (index + this.photos.length) % this.photos.length;
      const photo = this.photos[this.index];
      this.image.alt = photo.dataset.alt || '';
      this.image.src = photo.href;
      this.caption.textContent = photo.dataset.caption || '';
      this.caption.hidden = !this.caption.textContent;
      this.position.textContent = (this.index + 1) + ' / ' + this.photos.length;
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.dialog?.open) this.dialog.close();
    }
  });
}
